import { Host, Injectable, Optional } from '@angular/core';
import { AssetVariable } from '@iot-platform/models/i4b';
import { AbstractGridAssetVariableConfigureReadPopupService } from '../services/abstract-grid-asset-variable-configure-read-popup.service';

@Injectable({ providedIn: 'root' })
export class GridEngineSettingsService {
  constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    @Host()
    @Optional()
    private readonly assetVariableConfigureReadPopupService: AbstractGridAssetVariableConfigureReadPopupService
  ) {}

  updateAssetVariableThresholds(assetVariable: AssetVariable): void {
    this.assetVariableConfigureReadPopupService?.updateAssetVariableThresholds?.(assetVariable);
  }
}
